export const API_URI = process.env.API_URI || 'http://localhost:5000'
export const BLOG_URI = process.env.BLOG_URI || 'https://www.example.com/'
export const DOMAIN = process.env.DOMAIN || 'localhost:8000'

export const HUBSPOT_PORTAL_ID = process.env.HUBSPOT_PORTAL_ID 
export const HUBSPOT_FORM_ID = process.env.HUBSPOT_FORM_ID
